import { dateOnlySchema } from '@debts-system/contracts';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { CustomerPage, type CustomerTab } from '@/features/debts/customer-page.js';

/** A period handed over by the كشف العميل report; anything else is ignored. */
function periodParam(value: unknown): string | undefined {
  return dateOnlySchema.safeParse(value).success ? (value as string) : undefined;
}

interface CustomerSearch {
  tab?: CustomerTab;
  from?: string;
  to?: string;
}

/** The customer page (debts.md section 6.3); `tab=statement` opens كشف العميل. */
export const Route = createFileRoute('/_app/customers/$id')({
  validateSearch: (search: Record<string, unknown>): CustomerSearch => ({
    tab: search['tab'] === 'statement' || search['tab'] === 'accounts' ? search['tab'] : undefined,
    from: periodParam(search['from']),
    to: periodParam(search['to']),
  }),
  component: CustomerRoute,
});

function CustomerRoute() {
  const { id } = Route.useParams();
  const { tab, from, to } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  // Keyed by customer so another customer's page starts from its own state.
  return (
    <CustomerPage
      key={id}
      debtorId={id}
      tab={tab ?? (from || to ? 'statement' : 'accounts')}
      onTabChange={(next) =>
        void navigate({ search: (previous) => ({ ...previous, tab: next }), replace: true })
      }
      initialFrom={from}
      initialTo={to}
    />
  );
}
